import React from "react";
import "./style.css";
import classNames from "classnames";
export default function ButtonV2(props) {
    const { children, variant, onClick, className, itemRef, disableExtraSpacing } = props;
    return (React.createElement("button", { onClick: onClick, ref: itemRef, style: props.style, className: classNames("v2-button", {
            "v2-blank-button": variant === "blank",
            "v2-ghost-button": variant === "ghost",
            "v2-link-bold-button": variant === "link-bold",
            "v2-chip-button": variant === "chip",
            "no-spacing": disableExtraSpacing,
        }, className) }, children));
}
